// extracted by mini-css-extract-plugin
export default {"floatBtn":"index_floatBtn__adkAb","floatImg":"index_floatImg__GdL-7"};